import { apiClient } from './client'

export interface SystemSetting {
  id: number
  key: string
  value: string
  type: 'number' | 'string' | 'boolean' | 'json'
  group: string
  label: string
  description: string
  sort: number
  created_at: number
  updated_at: number
}

export interface SettingUpdateItem {
  key: string
  value: string
}

export const settingsApi = {
  // 获取设置列表
  getSettings: async (group?: string): Promise<SystemSetting[]> => {
    const params = new URLSearchParams()
    if (group) params.set('group', group)
    const response = await apiClient.get<SystemSetting[]>(
      `/settings?${params.toString()}`
    )
    return response.data
  },

  // 获取单个设置
  getSetting: async (key: string): Promise<SystemSetting> => {
    const response = await apiClient.get<SystemSetting>(
      `/settings/${key}`
    )
    return response.data
  },

  // 批量更新设置
  batchUpdate: async (items: SettingUpdateItem[]): Promise<void> => {
    await apiClient.put('/settings/batch', { items })
  },

  // 更新单个设置
  updateSetting: async (key: string, value: string): Promise<void> => {
    await apiClient.put(`/settings/${key}`, { value })
  },
}
